<template>
  <vg-card class="dp-application-applicant-form hidden no-padding">
    <vg-card class="form no-margin">
      <vg-form>
        <dp-application-field
            ref="fields"
            v-for="field in value"
            :key="field.applicationSituationId"
            :type="field.attributeType"
            :label="field.attributeName"
            :disabled="field.disable"
            :field-rule="field.fieldRule"
            v-model="field.value"
        />
      </vg-form>
    </vg-card>
    <div class="button-group">
      <van-image
          :class="{'hidden-button': !allowRemove}"
          width="24px"
          height="24px"
          :src="MinusSign"
          @click="remove(value)"
      />
      <van-image
          :class="{'hidden-button': !allowInsert}"
          width="24px"
          height="24px"
          :src="Plus"
          @click="insert(value)"
      />
    </div>
  </vg-card>
</template>

<script>
import minusSign from "@/assets/myElectronicPass/reduce.svg";
import plus from "@/assets/myElectronicPass/plus.svg";
import DpApplicationField
  from "@/views/DigitalPassApplications/DigitalPassApplicationForm/DpApplicationField/index.vue";
import {Image} from "vant";
import VgCard from "@/components/Commons/VgCard.vue";
import VgForm from "@/components/Commons/VgForm.vue";

export default {
  name: "DpApplicationApplicantField",
  components: {
    VgForm,
    VgCard,
    DpApplicationField,
    'van-image': Image
  },
  props: {
    value: [],
    allowInsert: Boolean,
    allowRemove: Boolean,
  },
  data() {
    return {
      MinusSign: minusSign,
      Plus: plus,
      startRemove: false,
      removed: false,
    }
  },
  methods: {
    input(value) {
      this.$emit('input', value)
    },
    insert(value) {
      this.$emit('insert', value)
    },
    remove(value) {
      this.$emit('remove', value)
    },
    validate() {
      return this.$refs.fields.map(field => field.validate())
    }
  }
}
</script>

<style scoped>
.hidden-button {
  visibility: hidden;
}

.dp-application-applicant-form {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 0;
}

.form {
  flex: 1;
}

.button-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 10px;
}

/*------*/


/* .choiceApprovalOperator >>> .van-picker__toolbar{
    background-color: #F7F7F9;

} */
.app {
  background-color: white;
  overflow: hidden;
  padding-bottom: 10px;
}

.applicant {
  margin-left: auto;
  border: 1px solid #E7E5E7;
  border-radius: 10px;
  margin: 20px 10px 20px 10px;
  padding-bottom: 10px;
}

.uploadPictures {
  border-radius: 10px;
  margin: 10px 0px 10px 15px;
  /* display: flex; */
}

.uploadPicturesTp {
  border-radius: 10px;
  margin: 10px 0px 10px 15px;
}

.addPhotoDiv {
  border: 1px solid #E7E5E7;
  border-radius: 10px;
  width: 50px;
  height: 50px;
  text-align: center;
}

.imgClass {
  /* vertical-align: text-top; */
  margin-left: auto;
}

.imgClass >>> .van-uploader__preview-delete {
  position: absolute;
  top: 0;
  right: 0;
  width: 14px;
  height: 14px;
  background-color: red;
  border-radius: 0 0 0 12px;
}

.imgClass >>> .van-uploader__preview-delete-icon {
  position: absolute;
  top: -4px;
  right: -5px;
  color: black;
  font-size: 22px;
  transform: scale(0.5);
}

.imgClass >>> .van-uploader__preview-image {
  width: 290px;
  height: 180px;
}

/* .imgClass>>>.van-image__img {
    width: 290px;
    height: 180px;
} */

.vantPopup >>> .van-overlay {
  background-color: #4C4C4C;
}
</style>